module.exports = __webpack_public_path__ + "static/media/edit_origin.eaa7f55a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flavours/coolRide/images/edit_origin.svg
// module id = 577
// module chunks = 0